import React from 'react';
import './styles/RegisterModal.css';
import { CloseSmall } from '@icon-park/react';
import { useRegister } from './hooks/useRegister';
import { BenefitTabs } from './components/BenefitTabs';
import { RegisterForm } from './components/RegisterForm';

/**
 * RegisterModal - 注册模态框主组件
 */
function RegisterModal({ isOpen, onClose, onSwitchToLogin, onRegisterSuccess }) {
  const {
    userType,
    benefitTab,
    formData,
    isSubmitting,
    error,
    success,
    canSendCode,
    verifyButtonLabel,
    resolvedBenefitType,
    handleBenefitTabChange,
    handleChange,
    handleGetCode,
    handleSubmit,
  } = useRegister(isOpen, onRegisterSuccess);

  if (!isOpen) return null;

  // 设置用户类型（从表单）
  const setUserType = (type) => {
    handleBenefitTabChange(type);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content register-modal" onClick={(e) => e.stopPropagation()}>
        {/* 关闭按钮 */}
        <button className="modal-close" onClick={onClose}>
          <CloseSmall theme="outline" size={18} fill="#333" strokeWidth={3} />
        </button>
        
        <div className="register-container">
          {/* 左侧权益卡片 */}
          <BenefitTabs
            benefitTab={benefitTab}
            resolvedBenefitType={resolvedBenefitType}
            onTabChange={handleBenefitTabChange}
          />
          
          {/* 右侧注册表单 */}
          <RegisterForm
            userType={userType}
            formData={formData}
            error={error}
            success={success}
            isSubmitting={isSubmitting}
            canSendCode={canSendCode}
            verifyButtonLabel={verifyButtonLabel}
            onUserTypeChange={setUserType}
            onChange={handleChange}
            onGetCode={handleGetCode}
            onSubmit={handleSubmit}
            onSwitchToLogin={onSwitchToLogin}
          />
        </div>
      </div>
    </div>
  );
}

export default RegisterModal;

